import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const Navbar = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const links = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Blog" },
    { to: "/best-breast-pumps", label: "Breast Pump Types" },
    { to: "/reviews", label: "Reviews" },
    { to: "/pumping-tips", label: "Pumping Tips" },
    { to: "/coupons", label: "Coupons" },
    { to: "/giveaway", label: "Giveaway" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border/50"
    >
      <nav className="max-w-6xl mx-auto px-5 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <img src="/logo.webp" alt="Mommy's Liquid Gold logo" width="48" height="48" decoding="async" className="h-12 w-12 object-contain" />
          <span className="font-heading text-xl font-bold tracking-tight">Mommy's Liquid Gold</span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`px-3 sm:px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                pathname === l.to
                  ? "bg-accent text-accent-foreground"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to={user ? "/admin" : "/login"}
            data-testid="nav-admin"
            className="ml-1 px-4 py-2 rounded-full bg-secondary text-secondary-foreground text-sm font-semibold hover:-translate-y-0.5 transition-transform"
          >
            {user ? "Dashboard" : "Admin"}
          </Link>
        </div>
      </nav>
    </header>
  );
};
